















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppUserVacationHistoryEditModel } from '@/services/api/nswag/stapiclient_generated';

@Component({
  components: {},
})
export default class AppUserVacationHistoryEdit extends Vue {
  @Prop() item!: AppUserVacationHistoryEditModel;
  @Prop() isFirstEntry!: boolean;
}
